export default __webpack_public_path__ + "svg/calendar/2027/7/octubre.svg?33da39a2";